import { CustomDiscountType } from "../OrderOnBehalfOf.shared";
import {
  calculateFlatDiscount,
  calculatePercentageDiscount,
} from "@sellar-io/common";

export const calculateCustomDiscountAmount = ({
  totalValue,
  customDiscount,
}: {
  totalValue: number;
  customDiscount: CustomDiscountType;
}) => {
  if (customDiscount.type === "percentage") {
    return calculatePercentageDiscount(totalValue, customDiscount.amount);
  }

  return calculateFlatDiscount({
    flatDiscount: customDiscount.amount,
    totalValue: totalValue,
  });
};
